import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { QuibblService } from '../../quibbl.service';

@Component({
  selector: 'quibbl-tree',
  templateUrl: './quibbl-tree.component.html',
  styleUrls: ['./quibbl-tree.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class QuibblTreeComponent implements OnInit {

  @Input() isInitialState: boolean = true;
  @Input() featured: boolean = false;
  @Input() category: string;
  @Input() limit: number = 0;

  public quibbls;
  public links;
  public quibblSubscription;

  public reachedEnd;
  public isFetching;
  public loadLimit = 12;

  public now = Date.now();

  constructor(private _qb: QuibblService) {  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if(this.quibblSubscription) this.quibblSubscription.unsubscribe();
  }

  ngOnChanges() {
    if(this.quibblSubscription) this.quibblSubscription.unsubscribe();

    if(this.featured) {
      this.quibblSubscription =
        this._qb.getQuibbls(null, -1, false, true).subscribe(quibbls => {
          if(quibbls) {
            this.quibbls = [];
            this.links = {};
            for(let i=quibbls.length-1; i>=0; i--) {
              this.quibbls.push(quibbls[i]);
              this.parseLinks(quibbls, i);
            }
          }
        });
    }

    else {
      let hardLimit = (this.limit < this.loadLimit && this.limit != 0) ? this.limit : this.loadLimit;
      this.reachedEnd = this.limit > 0 && this.limit < this.loadLimit;

      this.quibblSubscription =
        this._qb.getQuibbls(this.category, hardLimit).subscribe(quibbls => {
          if(quibbls) {
            if(quibbls.length < hardLimit) {
              this.reachedEnd = true;
            }
            this.quibbls = [];
            this.links = {};
            for(let i=quibbls.length-1; i>=0; i--) {
              this.quibbls.push(quibbls[i]);
              this.parseLinks(quibbls, i);
            }
          }
        });
    }

  }

  parseLinks(quibbls: any, index: number) {
    this.links[quibbls[index].$key] = [];
    if(quibbls[index].links) {
      let n = 0;
      for(let link of quibbls[index].links) {
        if(link) {
          let identifiers = link.split('.');
          let identifier = (identifiers.length == 2) ? identifiers[0] : identifiers[1];
          if(identifier) {
            let splitCheck = identifier.split('/');
            identifier = splitCheck[splitCheck.length-1];
            this.links[quibbls[index].$key][n] = {
              brand: identifier,
              link: link
            };
            n++;
          }
        }
      }
    }
  }

  public fetchMoreQuibbls() {
    if(this.reachedEnd || this.isFetching || !this.quibbls || !this.quibbls.length) {
      return;
    }

    //console.log("FETCHING");
    this.isFetching = true;

    if(this.quibblSubscription) this.quibblSubscription.unsubscribe();

    let newLimit = this.quibbls.length + this.loadLimit;
    let hardLimit = (this.limit < newLimit && this.limit != 0) ? this.limit : newLimit;
    this.quibblSubscription =
      this._qb.getQuibbls(this.category, hardLimit).subscribe(quibbls => {

        let diff = quibbls.length - this.quibbls.length;
        if(quibbls.length < hardLimit) {
          this.reachedEnd = true;
        }
        for(let i=diff-1; i>=0; i--) {
          if(quibbls[i]) {
            this.quibbls.push(quibbls[i]);
            this.parseLinks(quibbls, i);
          }

          else {
            this.reachedEnd = true;
            break;
          }
        }

        if(this.reachedEnd) {
          //console.log("reached end");
        }

        this.isFetching = false;

        //console.log(this.links);
      });

  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/category/quibbl-tree/quibbl-tree.component.ts